import React from 'react';
import { useHistory } from 'react-router-dom';
import CTA from '@molecules/CTA';
import Tabs from '@molecules/Tabs';
import SearchEventsRecommended from '../../../../icsc-app/js/components/searches/SearchEventsRecommended';
import SearchEventsSaved from '../../../../icsc-app/js/components/searches/SearchEventsSaved';

const MemberEventsLists = () => {
    const history = useHistory();

    return (
        <Tabs
            defaultActiveTab="registered"
            onTabChange={tabKey => {
                if (tabKey === 'upcoming') {
                    history.push('/my-icsc/events');
                }
            }}
        >
            <div tabKey="registered" title="Recommended Events">
                <div>
                    <div className="mb-1rem">
                        <CTA
                            headerText="Your connections will be attending these events."
                            ctaText="See All Events"
                            ctaUrl="/search?type=events"
                        />
                    </div>

                    <SearchEventsRecommended />
                </div>
            </div>

            <div tabKey="saved" title="Saved Events">
                <div>
                    <div className="mb-1rem">
                        <CTA headerText="These are the events you've saved." />
                    </div>

                    <SearchEventsSaved />
                </div>
            </div>

            <div tabKey="upcoming" title="My Upcoming Events" />
        </Tabs>
    );
};

MemberEventsLists.propTypes = {
    // events: PropTypes.array.isRequired,
};

export default MemberEventsLists;
